module.exports = __webpack_public_path__ + "img/p12.a06c8704.png";